import { StylesConfig } from 'react-select';

import { themes } from 'kb-shared';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const SelectContainer = styled.div`
  width: 100%;
`;

const widthAndColor = () => ({
  backgroundColor: themes.colors.yellow.lightestYellow,
  maxWidth: '420px'
});

export const SelectStyles: StylesConfig<{ value: string; label: string }, false> = {
  control: baseStyles => ({
    ...baseStyles,
    ...widthAndColor(),
    marginTop: 6
  }),
  valueContainer: baseStyles => ({ ...baseStyles, ...widthAndColor() })
};
